import { FC, PropsWithChildren, useState, useEffect } from 'react';
import { getLocaleData } from '@mb/lib/i18n';
import { IntlProvider as ReactIntlProvider, IntlConfig } from 'react-intl';

import * as styles from './styles';

export interface IntlProviderProps
  extends PropsWithChildren,
    Partial<IntlConfig> {}

interface Message {
  [key: string]: string;
}
interface LangDataProps {
  currentLocale: string;
  messages?: Message;
}

export const IntlProvider: FC<IntlProviderProps> = (props) => {
  const { ...intlProps } = props;

  const [langData, setLangData] = useState<LangDataProps>({
    currentLocale: 'en',
    messages: undefined,
  });

  useEffect(() => {
    handleLangData();
  }, []);

  const handleLangData = async () => {
    const data = await getLocaleData();

    setLangData(data);
  };

  return (
    <ReactIntlProvider
      messages={langData?.messages}
      locale={langData?.currentLocale}
      defaultLocale="en"
      defaultRichTextElements={{
        b: (chunks) => <span sx={styles.highlightedText}>{chunks}</span>,
      }}
      {...intlProps}
    />
  );
};
